export default {
  status: ["active", "disactive", "trial", "trial-expired", "cancelled"],
  subscriptions: ["VDA", "Prova", "PT"],
};
